import type { FaireProductEntity } from "../../entity_types/product";

export const p_dm4av5ug37: FaireProductEntity = {
  token: "p_dm4av5ug37",
  type: "product",
  name: "Fudgy Chocolate Brownies Freshly Baked (15)",
  brandToken: "b_rcvdagzk6f",
  brandName: "PHIVI BOX",
  imageUrl:
    "https://cdn.faire.com/fastly/ebe59c425c0976628704a8fece7d03217b5d97691da42a4c962258d7f945f296.webp",
  galleryImageUrls: [],
  priceDollars: 4.5,
  description:
    "Freshly baked and handmade Chocolate Brownies by Phivi Artisanal Desserts Box based in Brooklyn, NY. Made in the United States of America.\n\nOur Chocolate Brownies are thick, rich, chocolatey and fudgy! Each brownie weighs about 127 grams.\n\nOur brownies are:\n- Made with 100% premium ingredients\n- Always freshly baked by hand\n\nOur brownies can be kept at room temperature for up to two weeks but may be stored in a freezer when not actively on display. They have a shelf life of approximately 3 months when stored in the freezer. \n\nWe ship via FedEx Ground on Mondays, Tuesdays, or Wednesdays to ensure our brownies arrive fresh to you.",
  tags: [],
  msrpDollars: 9.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:32.220Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
